<script setup>
import { computed } from 'vue'
import CrossIcon from '@/assets/icons/cross.png'
import CheckIcon from '@/assets/icons/check.png'

const { img, title, options } = defineProps(['img', 'title', 'options'])
const imageSrc = computed(() => {
  return new URL(`../../assets/images/${img}.png`, import.meta.url).href
})

const emit = defineEmits(['selection'])

const onSelect = (index) => {
  emit('selection', index)
}

</script>

<template>
  <div class="component-container">
    <div class="component-card">
      <p class="heading-5">{{ title }}</p>
      <div class="img-wrapper">
        <div class="img-container">
          <img :src="imageSrc" alt="Image" />
        </div>
      </div>
    </div>
    <div class="like-buttons mt-24">
      <button
        @click="onSelect(0)"
        :class="`btn option-btn ${selectedIndex == 0 ? 'selected' : ''}`">
        <img :src="CrossIcon" :alt="'Cross icon'" class="icon" />
      </button>
      <button
        @click="onSelect(1)"
        :class="`btn option-btn ${selectedIndex == 1 ? 'selected' : ''}`">
        <img :src="CheckIcon" :alt="'Check icon'" class="icon" />
      </button>
    </div>
  </div>
</template>

<style scoped>

.component-container {
  align-items: center;
}

.like-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
  width: 90%;
}

.option-btn {
  border-radius: 100%;
  padding: 17px;
  display: flex;
  width: unset;
}

.icon {
  width: 24px;
  height: 24px;
}

.img-container {
  width: 250px;
  height: 300px;
  display: flex;
  justify-content: center
}

.img-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

img {
  height: 100%;
}

@media screen and (max-width: 850px) {
  .img-container {
    width: 200px;
    height: 250px;
  }
}

</style>
